module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headerComponent', {
    on: {
      "search": _vm.upEmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcb46f7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header/header.vue
// module id = 651
// module chunks = 31